import React from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import '../styles/EmployeesDashboard.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const EmployeesDashboard = () => {
  // Doughnut Chart Data for Department Wise Employees
  const doughnutData = {
    labels: ['Sales', 'Accounts', 'Purchase', 'Inventory', 'Customer Support', 'Others'],
    datasets: [{
      data: [7, 6, 4, 3, 3, 5],
      backgroundColor: ['#3b82f6', '#22c55e', '#f59e0b', '#a855f7', '#06b6d4', '#848a95'],
      borderWidth: 0,
      cutout: '72%',
    }],
  };

  const donutOptions = {
    plugins: { legend: { display: false }, tooltip: { enabled: true } },
    maintainAspectRatio: false,
  };

  // Mock Table Data for Employees
  const employeesData = [
    { id: 1, name: "Rahul Sharma", email: "rahul.sharma@email.com", empId: "EMP001", dept: "Sales", role: "Sales Manager", phone: "+91 98765 43210", status: "Active" },
    { id: 2, name: "Priya Mehta", email: "priya.mehta@email.com", empId: "EMP002", dept: "Accounts", role: "Accountant", phone: "+91 98765 43211", status: "Active" },
    { id: 3, name: "Amit Verma", email: "amit.verma@email.com", empId: "EMP003", dept: "Purchase", role: "Purchase Executive", phone: "+91 98765 43212", status: "Active" },
    { id: 4, name: "Neha Singh", email: "neha.singh@email.com", empId: "EMP004", dept: "Inventory", role: "Store Incharge", phone: "+91 98765 43213", status: "On Leave" },
    { id: 5, name: "Sanjay Patel", email: "sanjay.patel@email.com", empId: "EMP005", dept: "Sales", role: "Sales Executive", phone: "+91 98765 43214", status: "Active" },
    { id: 6, name: "Vikram Joshi", email: "vikram.joshi@email.com", empId: "EMP006", dept: "Accounts", role: "Account Assistant", phone: "+91 98765 43215", status: "Active" },
    { id: 7, name: "Anjali Gupta", email: "anjali.gupta@email.com", empId: "EMP007", dept: "Customer Support", role: "Support Executive", phone: "+91 98765 43216", status: "Active" },
    { id: 8, name: "Deepak Kumar", email: "deepak.kumar@email.com", empId: "EMP008", dept: "Delivery", role: "Delivery Boy", phone: "+91 98765 43217", status: "Inactive" },
    { id: 9, name: "Karan Malhotra", email: "karan.malhotra@email.com", empId: "EMP009", dept: "Marketing", role: "Marketing Executive", phone: "+91 98765 43218", status: "Active" },
    { id: 10, name: "Pooja Yadav", email: "pooja.yadav@email.com", empId: "EMP010", dept: "HR", role: "HR Executive", phone: "+91 98765 43219", status: "On Leave" }
  ];

  const upcomingBirthdays = [
    { name: "Amit Verma", date: "24 May", daysLeft: "2 Days Left" },
    { name: "Neha Singh", date: "28 May", daysLeft: "6 Days Left" },
    { name: "Karan Malhotra", date: "02 Jun", daysLeft: "11 Days Left" }
  ];

  return (
    <div className="emp-wrapper">
      
      {/* Top KPI Grid */}
      <div className="emp-kpi-grid">
        <div className="emp-card emp-kpi-card">
          <div className="emp-kpi-header">
            <div className="emp-icon-box emp-bg-purple-light"><i className="fa-solid fa-users emp-text-purple"></i></div>
            <div className="emp-kpi-info">
              <span className="emp-kpi-title">Total Employees</span>
              <h2 className="emp-kpi-value">28</h2>
              <div className="emp-kpi-meta">
                <span>All Employees</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="emp-card emp-kpi-card">
          <div className="emp-kpi-header">
            <div className="emp-icon-box emp-bg-green-light"><i className="fa-solid fa-user-check emp-text-green"></i></div>
            <div className="emp-kpi-info">
              <span className="emp-kpi-title">Active Employees</span>
              <h2 className="emp-kpi-value">24</h2>
              <div className="emp-kpi-meta">
                <span>Currently Working</span>
                <span className="emp-trend-green"><i className="fa-solid fa-arrow-up"></i> 12.5%</span>
              </div>
            </div>
          </div>
        </div>

        <div className="emp-card emp-kpi-card">
          <div className="emp-kpi-header">
            <div className="emp-icon-box emp-bg-orange-light"><i className="fa-solid fa-user-clock emp-text-orange"></i></div>
            <div className="emp-kpi-info">
              <span className="emp-kpi-title">On Leave</span>
              <h2 className="emp-kpi-value">2</h2>
              <div className="emp-kpi-meta">
                <span>This Month</span>
              </div>
            </div>
          </div>
        </div>

        <div className="emp-card emp-kpi-card">
          <div className="emp-kpi-header">
            <div className="emp-icon-box emp-bg-red-light"><i className="fa-solid fa-user-minus emp-text-red"></i></div>
            <div className="emp-kpi-info">
              <span className="emp-kpi-title">Inactive Employees</span>
              <h2 className="emp-kpi-value">2</h2>
              <div className="emp-kpi-meta">
                <span>Not Working</span>
              </div>
            </div>
          </div>
        </div>

        <div className="emp-card emp-kpi-card">
          <div className="emp-kpi-header">
            <div className="emp-icon-box emp-bg-teal-light"><i className="fa-solid fa-hand-holding-dollar emp-text-teal"></i></div>
            <div className="emp-kpi-info">
              <span className="emp-kpi-title">Total Payroll (May 2025)</span>
              <h2 className="emp-kpi-value">₹6,45,250</h2>
              <div className="emp-kpi-meta">
                <span>This Month</span>
                <span className="emp-trend-green"><i className="fa-solid fa-arrow-up"></i> 8.6%</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Layout Grid */}
      <div className="emp-main-layout">
        
        {/* LEFT COLUMN: Main Table */}
        <div className="emp-left-col">
          <div className="emp-card emp-p-24">
            
            {/* Filters Row */}
            <div className="emp-filters-row">
              <div className="emp-search-box">
                <i className="fa-solid fa-magnifying-glass"></i>
                <input type="text" placeholder="Search employee..." />
              </div>
              <div className="emp-dropdown">All Departments <i className="fa-solid fa-chevron-down"></i></div>
              <div className="emp-dropdown">All Designations <i className="fa-solid fa-chevron-down"></i></div>
              <div className="emp-dropdown">All Status <i className="fa-solid fa-chevron-down"></i></div>
              <button className="emp-btn-outline"><i className="fa-solid fa-filter"></i> More Filters</button>
            </div>

            {/* Data Table */}
            <div className="emp-table-wrapper">
              <table className="emp-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Employee</th>
                    <th>Employee ID</th>
                    <th>Department</th>
                    <th>Designation</th>
                    <th>Mobile</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {employeesData.map((row) => (
                    <tr key={row.id}>
                      <td className="emp-text-muted emp-fw-500">{row.id}</td>
                      <td>
                        <div className="emp-employee-cell">
                          <img src={`https://ui-avatars.com/api/?name=${row.name.replace(' ', '+')}&background=random&color=fff`} alt={row.name} className="emp-avatar" />
                          <div>
                            <div className="emp-fw-600">{row.name}</div>
                            <div className="emp-text-muted emp-text-xs">{row.email}</div>
                          </div>
                        </div>
                      </td>
                      <td className="emp-fw-500 emp-text-muted">{row.empId}</td>
                      <td className="emp-fw-500">{row.dept}</td>
                      <td>{row.role}</td>
                      <td>{row.phone}</td>
                      <td>
                        <span className={`emp-badge emp-badge-${row.status.toLowerCase().replace(' ', '-')}`}>{row.status}</span>
                      </td>
                      <td>
                        <div className="emp-actions-cell">
                          <button className="emp-action-btn"><i className="fa-regular fa-pen-to-square"></i></button>
                          <button className="emp-action-btn"><i className="fa-solid fa-ellipsis-vertical"></i></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="emp-pagination">
              <span className="emp-page-info">Showing 1 to 10 of 28 entries</span>
              <div className="emp-page-controls">
                <button className="emp-page-btn"><i className="fa-solid fa-chevron-left"></i></button>
                <button className="emp-page-btn emp-page-active">1</button>
                <button className="emp-page-btn">2</button>
                <button className="emp-page-btn">3</button>
                <button className="emp-page-btn"><i className="fa-solid fa-chevron-right"></i></button>
              </div>
              <div className="emp-page-size">
                Show <select defaultValue="10"><option value="10">10</option></select> per page
              </div>
            </div>

          </div>
        </div>

        {/* RIGHT COLUMN: Sidebar Cards */}
        <div className="emp-right-col">
          
          {/* Department Wise Donut */}
          <div className="emp-card emp-p-24">
            <h3 className="emp-card-title emp-mb-20">Department Wise Employees</h3>
            
            <div className="emp-donut-layout">
              <div className="emp-donut-wrapper">
                <Doughnut data={doughnutData} options={donutOptions} />
                <div className="emp-donut-center">
                  <strong className="emp-dc-value">28</strong>
                  <span className="emp-dc-label">Total</span>
                </div>
              </div>
              <div className="emp-donut-legend">
                <div className="emp-leg-item">
                  <span className="emp-dot emp-bg-blue"></span>
                  <div className="emp-leg-text"><strong>Sales</strong><span>7 (25.0%)</span></div>
                </div>
                <div className="emp-leg-item">
                  <span className="emp-dot emp-bg-green"></span>
                  <div className="emp-leg-text"><strong>Accounts</strong><span>6 (21.4%)</span></div>
                </div>
                <div className="emp-leg-item">
                  <span className="emp-dot emp-bg-orange"></span>
                  <div className="emp-leg-text"><strong>Purchase</strong><span>4 (14.3%)</span></div>
                </div>
                <div className="emp-leg-item">
                  <span className="emp-dot emp-bg-purple"></span>
                  <div className="emp-leg-text"><strong>Inventory</strong><span>3 (10.7%)</span></div>
                </div>
                <div className="emp-leg-item">
                  <span className="emp-dot emp-bg-teal"></span>
                  <div className="emp-leg-text"><strong>Customer Support</strong><span>3 (10.7%)</span></div>
                </div>
                <div className="emp-leg-item">
                  <span className="emp-dot emp-bg-gray"></span>
                  <div className="emp-leg-text"><strong>Others</strong><span>5 (17.9%)</span></div>
                </div>
              </div>
            </div>
          </div>

          {/* Upcoming Birthdays */}
          <div className="emp-card emp-p-24">
            <div className="emp-card-header">
              <h3 className="emp-card-title">Upcoming Birthdays</h3>
              <a href="#" className="emp-link">View All</a>
            </div>
            <div className="emp-bday-list">
              {upcomingBirthdays.map((bday, i) => (
                <div className="emp-bday-item" key={i}>
                  <img src={`https://ui-avatars.com/api/?name=${bday.name.replace(' ', '+')}&background=random&color=fff`} alt={bday.name} className="emp-avatar-sm" />
                  <div className="emp-bday-info">
                    <strong>{bday.name}</strong>
                    <span>{bday.date}</span>
                  </div>
                  <div className="emp-bday-right">
                    <span className="emp-pill-blue">{bday.daysLeft}</span>
                    <button className="emp-action-btn"><i className="fa-regular fa-calendar"></i></button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Actions */}
          <div className="emp-card emp-p-24">
            <h3 className="emp-card-title emp-mb-16">Quick Actions</h3>
            <div className="emp-quick-actions-grid">
              <div className="emp-qa-item">
                <div className="emp-icon-md emp-bg-purple-light emp-text-purple"><i className="fa-solid fa-user-plus"></i></div>
                <strong>Add Employee</strong>
              </div>
              <div className="emp-qa-item">
                <div className="emp-icon-md emp-bg-green-light emp-text-green"><i className="fa-solid fa-building-user"></i></div>
                <strong>Add Department</strong>
              </div>
              <div className="emp-qa-item">
                <div className="emp-icon-md emp-bg-orange-light emp-text-orange"><i className="fa-solid fa-clipboard-user"></i></div>
                <strong>Attendance Sheet</strong>
              </div>
              <div className="emp-qa-item">
                <div className="emp-icon-md emp-bg-red-light emp-text-red"><i className="fa-solid fa-file-invoice-dollar"></i></div>
                <strong>Salary Register</strong>
              </div>
            </div>
          </div>

          {/* Payroll Summary */}
          <div className="emp-card emp-p-24">
            <div className="emp-card-header">
              <h3 className="emp-card-title">Payroll Summary <span className="emp-text-muted emp-fw-normal">(May 2025)</span></h3>
              <a href="#" className="emp-link">View Report</a>
            </div>
            <div className="emp-payroll-list">
              <div className="emp-pr-row">
                <span className="emp-text-muted">Total Employees</span>
                <strong className="emp-fw-600">28</strong>
              </div>
              <div className="emp-pr-row">
                <span className="emp-text-muted">Total Payable</span>
                <strong className="emp-fw-600">₹6,45,250</strong>
              </div>
              <div className="emp-pr-row">
                <span className="emp-text-muted">Paid</span>
                <strong className="emp-text-green">₹6,20,000</strong>
              </div>
              <div className="emp-pr-row">
                <span className="emp-text-muted">Due</span>
                <strong className="emp-text-red">₹25,250</strong>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default EmployeesDashboard;